if (!window.SwymCallbacks) window.SwymCallbacks = []
window.SwymCallbacks.push(initSwymUI)

let swat
let settings
let sectionId
let swatElements

function initSwymUI(swatInstance) {
	console.log('initSwymUI called', swatInstance)
	swat = swatInstance

	const wishlistElement = document.querySelector('.swymcs-custom-wishlist')
	if (!wishlistElement) {
		console.error('Wishlist element not found')
		return
	}

	try {
		settings = JSON.parse(wishlistElement.dataset.settings)
	} catch (e) {
		console.error('Failed to parse settings JSON', e)
		return
	}

	sectionId = wishlistElement.dataset.sectionid

	swatElements = {
		loader: document.querySelector('#swymcs-wishlist-loader'),
		container: document.querySelector('#swymcs-wishlist-container'),
		listOptions: document.querySelector(
			'#swymcs-wishlist-list-options-container'
		),
		itemsContainer: document.querySelector(
			'#swymcs-wishlist-items-container'
		), // <-- global search
		emptyContainer: document.querySelector(
			'#swymcs-empty-wishlist-container'
		),
	}

	if (!swatElements.itemsContainer) {
		console.warn('itemsContainer element not found')
	}

	fetchWishlist()
}

function fetchWishlist() {
	showLoader()

	if (!swat || !swat.fetchLists) {
		console.error('swat or swat.fetchLists is not defined')
		hideLoader()
		updateUIState([])
		return
	}

	console.log('Fetching wishlist...')
	swat.fetchLists({
		callbackFn: (lists) => {
			console.log('Lists fetched:', lists)
			if (!lists || lists.length === 0) {
				console.warn('No lists returned')
				updateUIState([])
				hideLoader()
				return
			}
			lists = lists.reverse()
			const selectedList = lists[0]

			const currentListId =
				swat.swymCustomWishlistSelectedListId || selectedList?.lid
			swat.swymCustomWishlistSelectedListId = currentListId

			renderList(selectedList.listcontents || [])
		},
		errorFn: (error) => {
			console.error('Error while fetching all Lists', error)
			hideLoader()
			updateUIState([])
		},
	})
}

async function renderList(list) {
	if (!swatElements.itemsContainer) {
		console.error('itemsContainer element not found')
		return
	}

	swatElements.itemsContainer.innerHTML = ''
	if (list.length > 0) {
		const wishlistedProducts = await fetchProductData(list)
		wishlistedProducts.forEach(renderWishlistItem)
	}
	updateUIState(list)
}

async function fetchProductData(wishlist) {
	const productDataPromises = wishlist.map(async (listItem) => {
		try {
			const url = `${listItem.du.split('?')[0]}.js`
			const response = await fetch(url)
			if (!response.ok) {
				console.error('Failed to fetch product data for', url)
				return listItem // Return original item without productData
			}
			listItem.productData = await response.json()
			return listItem
		} catch (e) {
			console.error('Error fetching product data for', listItem.du, e)
			return listItem
		}
	})
	return await Promise.all(productDataPromises)
}

function renderWishlistItem(item) {
	const wishlistItem = document.createElement('div')
	wishlistItem.classList.add('swymcs-wishlistplus-item')
	wishlistItem.classList.add('wishlist--item')
	wishlistItem.dataset.epi = item.epi
	wishlistItem.dataset.empi = item.empi
	wishlistItem.dataset.du = item.du
	wishlistItem.dataset.sectionid = sectionId

	const productImage = item.productData?.featured_image || item.iu || ''
	const selectedVariant = item.productData?.variants?.find(
		(variant) => variant.id == item.epi
	)
	const isInCart = _swat?.platform?.isInDeviceCart(selectedVariant?.id)
	const getButtonState = () =>
		selectedVariant?.available
			? isInCart
				? settings.swym_wishlist_item_cta_addedtocart
				: settings.swym_wishlist_item_cta_addtocart
			: settings.swym_wishlist_item_cta_soldout

	wishlistItem.innerHTML = `
    <a href="${item.du}" class="swymcs-wishlist-image-container">
      <img src="${productImage}" class="swymcs-wishlistplus-item-image" />
    </a>
    <div class="wishlist--item--content">
      <div style="display: flex;flex-direction: column; gap: 0.5rem;">
      ${
			settings.swym_wishlist_show_vendor
				? `<div class="swymcs-wishlistplus-item-vendor-type">${
						item.productData?.vendor || ''
				  }</div>`
				: ''
		}
      <a href="${item.du}" class="swymcs-wishlistplus-item-title">
        <div class="swymcs-wishlistplus-item-title-content">${item.dt}</div>
      </a>
      <div class="swymcs-wishlistplus-item-variant">${
			item.productData
				? getVariantStringWithoutStyle(item)
				: item.vi || ''
		}</div>
      </div>
      <div>
      ${
			settings.swym_wishlist_show_price
				? `<div class="swymcs-product-final-price">${renderPrice(
						item
				  )}</div>`
				: ''
		}
      </div>
      <div class="swymcs-wishlist-action-container">
        ${
			settings.swym_wishlist_show_addtocart
				? `<button class="button button--secondary" style="min-width: 175px;" data-action="add-to-cart" ${
						!selectedVariant?.available ? 'disabled' : ''
				  }>${getButtonState()}</button>`
				: ''
		}
      </div>
    </div>
    ${
		settings.swym_wishlist_show_delete_item
			? `
      <button id="swymcs-remove-productBtn" aria-label="Delete" class="swymcs-wishlistplus-item-remove">
        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="26" viewBox="0 0 27 26" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M6.36531 21.3036L5.19583 20.1339L5.19531 20.1344L6.36531 21.3036ZM13.4991 12.1152L20.6328 4.979L21.5191 5.86532L14.3838 12.9999L21.5191 20.1345L20.6336 21.02L13.499 13.8846L6.36524 21.0208L5.47822 20.1344L12.6144 12.9999L5.47818 5.86611L6.36449 4.9798L13.4991 12.1152Z" fill="#343433"/>
        </svg>
      </button>`
			: ''
	}
  `

	wishlistItem
		.querySelector('[data-action="add-to-cart"]')
		?.addEventListener('click', (event) => {
			event.preventDefault()
			let button = event.target

			let { empi, epi, du, qty } = item

			let originalButtonState = button.innerHTML
			button.innerHTML = settings.swym_wishlist_item_cta_addingtocart

			swat.replayAddToCart(
				{ empi: empi, du: du, qty: qty },
				epi,
				(success) => {
					button.innerHTML =
						settings.swym_wishlist_item_cta_addedtocart
					const variant = JSON.parse(success).items[0]
					const productTitle = variant.title
					let successMessage = `<strong>${productTitle}</strong> has been added to cart!`
					swat.ui.showSuccessNotification({ message: successMessage })

					fetch(
						`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`
					)
						.then((response) => response.json())
						.then((sections) => {
							// Handle cart-drawer replacement
							const cartDrawerHTML = sections['cart-drawer']
							if (cartDrawerHTML) {
								const tempDrawer = document.createElement('div')
								tempDrawer.innerHTML = cartDrawerHTML
								const newCartDrawer =
									tempDrawer.querySelector('cart-drawer')

								const currentCartDrawer =
									document.querySelector('cart-drawer')
								if (newCartDrawer && currentCartDrawer) {
									currentCartDrawer.replaceWith(newCartDrawer)
								}
							}

							// Handle cart-icon-bubble content replacement
							const bubbleHTML = sections['cart-icon-bubble']
							if (bubbleHTML) {
								const wrapper = document.createElement('div')
								wrapper.innerHTML = bubbleHTML

								const target =
									document.querySelector('#cart-icon-bubble')
								if (target) {
									// Clear out existing contents
									while (target.firstChild) {
										target.removeChild(target.firstChild)
									}

									// Inject new contents
									Array.from(wrapper.childNodes).forEach(
										(child) => {
											target.appendChild(child)
										}
									)
								} else {
									console.warn(
										'[WARN] Could not find #cart-icon-bubble in DOM'
									)
								}
							}

							// Clean up empty state if it exists
							const cartDrawer =
								document.querySelector('cart-drawer')
							cartDrawer?.classList.remove('is-empty')

							const emptyState = cartDrawer?.querySelector(
								'.drawer__inner-empty'
							)
							if (emptyState) {
								emptyState.remove()
							}

							publish(PUB_SUB_EVENTS.cartUpdate, {
								source: 'custom-add-to-cart',
								cartData: null,
								variantId: variant.id,
							})

							document
								.querySelector('#CartDrawer-Checkout')
								?.removeAttribute('disabled')

							if (cartDrawer) {
								cartDrawer.open()
							}
						})
				},
				(error) => {
					button.innerHTML = originalButtonState
					swat.ui.showErrorNotification({
						message: error.description,
					})
				}
			)
		})

	wishlistItem
		.querySelector('#swymcs-remove-productBtn')
		?.addEventListener('click', () => {
			let product = {
				epi: item.epi,
				empi: item.empi,
				du: item.du,
			}
			_swat.deleteFromList(
				_swat.swymCustomWishlistSelectedListId,
				product,
				() => {
					fetchWishlist()
				},
				(error) =>
					console.error('Failed to remove from wishlist', error)
			)
		})

	swatElements.itemsContainer.appendChild(wishlistItem)
}

function updateUIState(wishlist) {
	hideLoader()
	if (wishlist.length > 0) {
		swatElements.container.classList.remove('swymcs-hide-container')
		swatElements.emptyContainer.classList.add('swymcs-hide-container')
	} else {
		swatElements.emptyContainer.classList.remove('swymcs-hide-container')
		swatElements.container.classList.add('swymcs-hide-container')
	}
}

function showLoader() {
	swatElements.loader?.classList.remove('swymcs-hide-container')
}

function hideLoader() {
	swatElements.loader?.classList.add('swymcs-hide-container')
}

function cleanProductVariableString(input) {
	const parts = input.split('/')
	return parts.slice(0, 2).join('/')
}

function formatPrice(valueInCents) {
	const currencyCode = Shopify?.currency?.active || 'AUD'
	const locale = Shopify?.locale || 'en-AU'

	const formatted = new Intl.NumberFormat(locale, {
		style: 'currency',
		currency: currencyCode,
	}).format(valueInCents / 100)

	return currencyCode === 'AUD' ? formatted.replace(/^A/, '') : formatted
}

function renderPrice(item) {
	// Get the current price and compare_at_price from productData or fallback to pr
	const product = item?.productData

	const price =
		product?.price ?? (typeof item?.pr === 'number' ? item.pr * 100 : 0)
	const compareAtPrice = product?.compare_at_price ?? 0

	const isOnSale = compareAtPrice > price

	if (isOnSale) {
		return `
      <div class="prices">
        <span class="price--sale">${formatPrice(price)}</span>
        <span class="price--compare" style="text-decoration: line-through; color: #888; margin-left: 0.5em;">
          ${formatPrice(compareAtPrice)}
        </span>
      </div>
    `
	} else {
		return `<div class="prices">${formatPrice(price)}</div>`
	}
}

function getVariantStringWithoutStyle(item) {
	const productData = item.productData
	if (!productData) return item.vi || ''

	const variant = productData.variants.find((v) => v.id === item.epi)
	if (!variant) return item.vi || ''

	return variant.options
		.map((value, index) => {
			const optionMeta = productData.options[index]
			return optionMeta?.name === 'Style' ? null : value
		})
		.filter(Boolean)
		.join(' / ')
}
